import React from "react";
import "../../components/Page/page_header.css";
import { useSidebar } from "../../components/ui/sidebar";
import Denda from "./Logos/Denda.png";
import Azerion from "./Logos/Azerion.png";
import CNN from "./Logos/CNN.png";
import DPG from "./Logos/dpg.png";
import { useNavigate } from "react-router-dom";
import { UserRoundCog, LogOut, Settings } from "lucide-react";
import { Avatar, AvatarImage, AvatarFallback } from "../../components/ui/avatar";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "../../components/ui/dropdown";
import { post } from "../../lib/api";

export const Profile = () => {
  const { setAuthenticated, setSidebarOpen, brand, user} = useSidebar();

  const navigate = useNavigate();

  const userIcons = {
    // a dictionary mapping brand names to their icons, names are the keys and the icons are the values
    Denda: Denda,
    CNN: CNN,
    DPG: DPG,
    Azerion: Azerion,
  };

  function handlePage(page) {
    navigate(`/${page}`);
  }

  const handleLogout = async () => {
    await post({}, "/logout"); // Wait for logout to complete

    setAuthenticated(false);
    setSidebarOpen(false);

    navigate("/");
    window.location.reload(); // Now safe to reload
  };

  // Get the current brand value from the app context

  return (
    <div className="user-profile hover:bg-purple-200">
      {/* Main container for the profile section */}

      <DropdownMenu>
        {/* Trigger the dropdown when avatar is clicked */}
        <DropdownMenuTrigger asChild>
          <Avatar sx={{ cursor: "pointer" }}>
            <AvatarImage src={userIcons[brand]} alt="User Avatar" />
            <AvatarFallback className={"text-[0.55rem] items-center justify-center "}>{brand}</AvatarFallback>
          </Avatar>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="text-black">


          {
            brand === "Denda" || brand === "testing" ?(
                <DropdownMenuItem onClick={() => handlePage(`Administration`)}>
                  <UserRoundCog className="size-4 font-bold" />
                  Administration
                </DropdownMenuItem>
            ): ("")
          }


          <DropdownMenuItem onClick={() => handlePage(`Settings`)}>
            <Settings className="size-4 font-bold" />
            Settings
          </DropdownMenuItem>

          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleLogout}>
            <LogOut className="dropdown-icon" /> Logout
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default Profile;
